import React, { useEffect, useState } from "react";
import MarketingLayout from "components/layout/MarketingLayout";
import { Button } from "components/ui";
import { ROUTES } from "constants/index";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Cta from "./home/Cta";
import { packagesService } from 'services/packages.service';
import parse,{ domToReact, HTMLReactParserOptions, Element, DOMNode }  from "html-react-parser";
import { Package, getPriceByDuration, getDetailByDuration, isDemoPackage } from "types/package";
import { useAuth } from "hooks/useAuth";

const PricingPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const isFreeTrial = searchParams.get('freeTrial') === 'true';
  const isUpgrade = searchParams.get('upgrade') === 'true';

  useEffect(() => {
    if (isUpgrade && isAuthenticated) {
      navigate(ROUTES.UPGRADE_PACKAGE, { replace: true });
    }
  }, [isUpgrade, isAuthenticated, navigate]);
  const [yearlyPrice, setYearly] = useState(true);
  const [yearlyStates, setYearlyStates] = useState<{ [key: string]: boolean }>({});
  const [company, setCompany] = useState(true);
  const [companyPackages,setCompanyPackages] = useState<Package[]>([]);
  const [individualPackages,setIndividualPackages] = useState<Package[]>([]);
  const [freeTrialPackages, setFreeTrialPackages] = useState<Package[]>([]);
  const [cmpPacksCount,setCmpPacksCount] = useState<string>("4")
  const [individualPacksCount,setIndividualPacksCount] = useState<string>("4")
  const [freeTrialPacksCount, setFreeTrialPacksCount] = useState<string>("4")
  
  useEffect(() => {
  packagesService.getAll().then((data) => {
    if(data && data.length >0){
      let cmpPacks = data.filter(p => p.isIndividual === false)??[];
      let indvPacks = data.filter(p => p.isIndividual === true)??[];
       
      if (isAuthenticated) {
        cmpPacks = cmpPacks.filter(p => !isDemoPackage(p));
        indvPacks = indvPacks.filter(p => !isDemoPackage(p));
      }
      const freePacks = data.filter(p => isDemoPackage(p)) ?? [];
      setCompanyPackages(cmpPacks);
      setIndividualPackages(indvPacks);
      setFreeTrialPackages(freePacks);
    }
  });
},[isAuthenticated]);
useEffect(() => {
      const indvPacks = individualPackages??[];
      const cmpPacks = companyPackages??[];
      const freePacks = freeTrialPackages??[];
      if(Number(indvPacks.length) > 0 && Number(indvPacks.length) < 4){
        setIndividualPacksCount(indvPacks.length.toString())
      }
      if(Number(cmpPacks.length) > 0 && Number(cmpPacks.length) < 4){
        setCmpPacksCount(cmpPacks.length.toString())
      }
      if(Number(freePacks.length) > 0 && Number(freePacks.length) < 4){
        setFreeTrialPacksCount(freePacks.length.toString())
      }
}, [companyPackages, individualPackages, freeTrialPackages]);

const options: HTMLReactParserOptions = {
  replace: (domNode: DOMNode) => {
    if (domNode instanceof Element) {
      if (domNode.name === 'ul') {
        return (
          <ul className="list-disc pl-5">
            {domToReact(domNode.children as DOMNode[], options)}
          </ul>
        );
      }
      if (domNode.name === 'ol') {
        return (
          <ol className="list-decimal pl-5">
            {domToReact(domNode.children as DOMNode[], options)}
          </ol>
        );
      }
    }
  },
};

  return (
    <MarketingLayout>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary-100 via-white to-white" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-secondary-900">
            Simple, transparent pricing for teams of all sizes
          </h1>
          <p className="mt-3 text-secondary-700">
            Switch anytime. No hidden fees.
          </p>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-6xl px-3 sm:px-5 lg:px-6 pb-8 mt-2">
          {!isFreeTrial && (
            <div className="flex justify-center">
              <div className="mt-3 mb-6 inline-flex justify-center items-center rounded-full border border-secondary-300 bg-white p-1">
                <button
                  onClick={() => setCompany(true)}
                  className={`px-4 py-2 rounded-full text-sm font-medium ${
                    company ? "bg-primary-600 text-white" : "text-secondary-800"
                  }`}
                >
                  Company
                </button>
                <button
                  onClick={() => setCompany(false)}
                  className={`px-4 py-2 rounded-full text-sm font-medium ${
                    !company ? "bg-primary-600 text-white" : "text-secondary-800"
                  }`}
                >
                  Individual
                </button>
              </div>
            </div>
          )}
          <div className="flex justify-center w-full">
          <div 
            className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-items-center items-stretch"
            style={{
              maxWidth: '100%',
              width: '100%'
            }}
          >
            {isFreeTrial
              ? freeTrialPackages.map((t) => {
                  const isYearly = yearlyStates[t.name] ?? false;
                  const priceValue = getPriceByDuration(t, isYearly);
                  const price = priceValue === 0 ? "$0" : `$${priceValue}`;
                  const highlight = t.name === "Pro";
                  return (
                    <div
                      key={t.name}
                      className={`mx-auto rounded-2xl border w-[260px] h-full ${
                        highlight
                          ? `bg-gradient-to-b from-white to-primary-10`
                          : `bg-gradient-to-b from-white to-secondary-10`
                      } shadow-sm flex flex-col`}
                      style={{
                        borderColor: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <div className="p-5 flex flex-col flex-1">
                      <h3 className="text-lg font-bold text-secondary-900 py-2 ">
                        {t.title}
                      </h3>
                      <div
                        className="inline-flex items-center rounded-full 
                    border border-secondary-300 bg-white p-1 text-[11px] w-fit ml-[-0.5rem] mb-3"
                      >
                        <button
                          onClick={() =>setYearlyStates((prev) => ({ ...prev, [t.name]: false }))}
                          className={`px-2 py-0.5 rounded-full ${
                            !isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Monthly
                        </button>

                        <button
                          onClick={() => setYearlyStates((prev) => ({ ...prev, [t.name]: true }))}
                          className={`px-3 py-0.5 rounded-full ${
                            isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Yearly
                        </button>
                      </div>
                      <p className="mt-2 text-3xl font-bold text-secondary-900">
                        {price}
                        <span className="text-base font-normal text-secondary-600">
                          {isYearly ? "/yr" : "/mo"}
                        </span>
                      </p>
                      <div className="mt-6">
                        <Link
                          to={(() => {
                          const detail = getDetailByDuration(t, isYearly);
                          const registerUrl = detail
                            ? `${ROUTES.REGISTER}?packageDetailsId=${detail.id}`
                            : `${ROUTES.REGISTER}/${t.id}?isYearly=${isYearly}`;
                          return isAuthenticated
                            ? `${ROUTES.UPGRADE_PAYMENT}/${t.id}?isYearly=${isYearly}`
                            : registerUrl;
                        })()}
                        >
                          <Button className="w-full">Get {t.name.split(" ")[0]}</Button>
                        </Link>
                      </div>
                      <div className="mt-2 text-secondary-600">{parse(t.description,options)}</div>
                      </div>
                    </div>
                  );
                })
              : company
              ? companyPackages.map((t) => {
                  const isYearly = yearlyStates[t.name] ?? false;
                  const priceValue = getPriceByDuration(t, isYearly);
                  const price = priceValue === 0 ? "$0" : `$${priceValue}`;
                  const highlight = t.name === "Pro";
                  return (
                    <div
                      key={t.name}
                      className={`mx-auto rounded-2xl border w-[260px] h-full ${
                        highlight
                          ? `bg-gradient-to-b from-white to-primary-10`
                          : `bg-gradient-to-b from-white to-secondary-10`
                      } shadow-sm flex flex-col`}
                      style={{
                        borderColor: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <div className="p-5 flex flex-col flex-1">
                      <h3 className="text-lg font-bold text-secondary-900 py-2 ">
                        {t.title}
                      </h3>
                      <div
                        className="inline-flex items-center rounded-full 
                    border border-secondary-300 bg-white p-1 text-[11px] w-fit ml-[-0.5rem] mb-3"
                      >
                        <button
                          onClick={() =>setYearlyStates((prev) => ({ ...prev, [t.name]: false }))}
                          className={`px-2 py-0.5 rounded-full ${
                            !isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Monthly
                        </button>

                        <button
                          onClick={() => setYearlyStates((prev) => ({ ...prev, [t.name]: true }))}
                          className={`px-3 py-0.5 rounded-full ${
                            isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Yearly
                        </button>
                      </div>
                      <p className="mt-2 text-3xl font-bold text-secondary-900">
                        {price}
                        <span className="text-base font-normal text-secondary-600">
                          {isYearly ? "/yr" : "/mo"}
                        </span>
                      </p>
                      <div className="mt-6">
                        <Link
                          to={(() => {
                          const detail = getDetailByDuration(t, isYearly);
                          const registerUrl = detail
                            ? `${ROUTES.REGISTER}?packageDetailsId=${detail.id}`
                            : `${ROUTES.REGISTER}/${t.id}?isYearly=${isYearly}`;
                          return isAuthenticated
                            ? `${ROUTES.UPGRADE_PAYMENT}/${t.id}?isYearly=${isYearly}`
                            : registerUrl;
                        })()}
                        >
                          <Button className="w-full">Get {t.name.split(" ")[0]}</Button>
                        </Link>
                      </div>
                      <div className="mt-2 text-secondary-600">{parse(t.description,options)}</div>
                      </div>
                    </div>
                  );
                })
              : individualPackages.map((t) => {
                  const isYearly = yearlyStates[t.name] ?? false;
                  const priceValue = getPriceByDuration(t, isYearly);
                  const price = priceValue === 0 ? "$0" : `$${priceValue}`;
                  const highlight = t.name === "Pro";
                  return (
                    <div
                      key={t.name}
                      className={`mx-auto rounded-2xl border w-[260px] h-full ${
                        highlight
                          ? `bg-gradient-to-b from-white to-primary-10`
                          : `bg-gradient-to-b from-white to-secondary-10`
                      } shadow-sm flex flex-col`}
                      style={{
                        borderColor: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <div className="p-5 flex flex-col flex-1">
                      <h3 className="text-lg font-bold text-secondary-900 py-2 ">
                        {t.title}
                      </h3>
                      <div
                        className="inline-flex items-center rounded-full 
                    border border-secondary-300 bg-white p-1 text-[11px] w-fit ml-[-0.5rem] mb-3"
                      >
                        <button
                          onClick={() =>setYearlyStates((prev) => ({ ...prev, [t.name]: false }))}
                          className={`px-2 py-0.5 rounded-full ${
                            !isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Monthly
                        </button>

                        <button
                          onClick={() => setYearlyStates((prev) => ({ ...prev, [t.name]: true }))}
                          className={`px-3 py-0.5 rounded-full ${
                            isYearly
                              ? "bg-primary-600 text-white"
                              : "text-secondary-800"
                          }`}
                        >
                          Yearly
                        </button>
                      </div>
                      <p className="mt-2 text-3xl font-bold text-secondary-900">
                        {price}
                        <span className="text-base font-normal text-secondary-600">
                          {isYearly ? "/yr" : "/mo"}
                        </span>
                      </p>
                      <div className="mt-6">
                        <Link to={(() => {
                          const detail = getDetailByDuration(t, isYearly);
                          const registerUrl = detail
                            ? `${ROUTES.REGISTER}?packageDetailsId=${detail.id}`
                            : `${ROUTES.REGISTER}/${t.id}?isYearly=${isYearly}`;
                          return isAuthenticated
                            ? `${ROUTES.UPGRADE_PAYMENT}/${t.id}?isYearly=${isYearly}`
                            : registerUrl;
                        })()}>
                          <Button className="w-full">Get {t.name.split(" ")[0]}</Button>
                        </Link>
                      </div>
                      <div className="mt-2 text-secondary-600">{parse(t.description,options)}</div>
                      </div>
                    </div>
                  );
                })
                }

          </div>
          </div>
        </div>
      </section>
      <Cta />
    </MarketingLayout>
  );
};

export default PricingPage;
